// @flow
import { getDaysBetween, getMonthsBetween, getDaysInYear } from './date';
import { frequencyTypes } from '../common/enums/FrequencyTypes';

import type { DateObject } from '@cmsgov/ds-healthcare-gov';
import type { Income } from '../components/IncomeCalculator/IncomeCalculator';
import { OrderedMap } from 'immutable';

export function weeklyAmountToIncome(amount: string, startDate: DateObject, endDate: DateObject): string {
  const days = getDaysBetween(startDate, endDate);
  return ((days / 7) * parseFloat(amount)).toFixed(2);
}

export function monthlyAmountToIncome(amount: string, startDate: DateObject, endDate: DateObject): string {
  const months = getMonthsBetween(startDate, endDate);
  return (months * parseFloat(amount)).toFixed(2);
}

export function yearlyAmountToIncome(amount: string, startDate: DateObject, endDate: DateObject): string {
  const days = getDaysBetween(startDate, endDate);
  // startDate and endDate should have same year, so just pull year from startDate
  const daysInYear = getDaysInYear(startDate.year);
  return ((days / daysInYear) * parseFloat(amount)).toFixed(2);
}

export function frequencyAmountToIncome(
  frequency: string,
  amount: string,
  startDate?: DateObject,
  endDate?: DateObject
): number {
  switch (frequency) {
    case frequencyTypes.WEEKLY: {
      return parseFloat(weeklyAmountToIncome(amount, startDate, endDate));
    }
    case frequencyTypes.MONTHLY: {
      return parseFloat(monthlyAmountToIncome(amount, startDate, endDate));
    }
    case frequencyTypes.YEARLY: {
      return parseFloat(yearlyAmountToIncome(amount, startDate, endDate));
    }
    // covers one-time only, just pass amount up without any calculations
    default: {
      return parseFloat(amount);
    }
  }
}

export function getIncomeTypeIndex(income: Income, stateIncomes: OrderedMap<string, Income>) {
  return stateIncomes
    .filter((i) => i.incomeType === income.incomeType)
    .toIndexedSeq()
    .findKey((i) => i.id === income.id);
}
